module.exports = __webpack_public_path__ + "img/enjoy.76d634c6.svg";